module.exports = __webpack_public_path__ + "static/media/01_blanco.9ec51338.svg";